import { getAllTotal } from '@/api/societe/index';

export default async function addSocieteAndAgence(utilisateur) {
  const societes = (await getAllTotal()).data.result.items;
  utilisateur.agence = {
    agenceId: societes[0].agences[0].id,
    codeAgence: societes[0].agences[0].codeAgence,
    codeSociete: societes[0].codeSociete,
    libelleAgence: societes[0].agences[0].libelle,
    libelleSociete: societes[0].libelle,
    selected: true,
    societeId: societes[0].id,
    regimeTvaId: societes[0].agences[0].regimeTvaId,
  };
  utilisateur.agenceId = societes[0].agences[0].id;
  utilisateur.agences = [];
  societes.forEach((societe) => {
    societe.agences.forEach((agence) => {
      utilisateur.agences.push({
        agenceId: agence.id,
        codeAgence: agence.codeAgence,
        codeSociete: societe.codeSociete,
        libelleAgence: agence.libelle,
        libelleSociete: societe.libelle,
        selected: false,
        societeId: societe.id,
        regimeTvaId: agence.regimeTvaId,
      });
    });
  });
  const agenceActive = utilisateur.agences.find((agence) => {
    return utilisateur.agence.agenceId === agence.agenceId;
  });
  agenceActive.selected = true;
}
